import getIcon from '../common/utils/icon';
import { getPrice, getSelected, getGraphQlSelection, getDBFGraphQlSelection } from '../../single-choice/utils/selection';
import { TRAVEL_INSURANCE_INSIDE_EU } from '../../products';
import TravelInsuranceInsideEu from './components/TravelInsuranceInsideEu';
const formSection = TRAVEL_INSURANCE_INSIDE_EU.name;
export const travelInsuranceInsideEu = {
  formSection,
  getIcon,
  getPrice: getPrice.bind(null, formSection),
  getSelected: getSelected.bind(null, formSection),
  getGraphQlSelection: getGraphQlSelection(formSection, 'traveler'),
  getDBFGraphQlSelection: getDBFGraphQlSelection(formSection, 'traveler'),
  ...TRAVEL_INSURANCE_INSIDE_EU
};
export default TravelInsuranceInsideEu;
//# sourceMappingURL=index.js.map